var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.659 15.3346H12.9935V11.1578C12.9935 10.1618 12.9733 8.88011 11.6045 8.88011C10.2148 8.88011 10.0025 9.96391 10.0025 11.0843V15.3346H7.33695V6.74561H9.89745V7.91631H9.93195C10.2897 7.24131 11.1597 6.52886 12.4594 6.52886C15.1602 6.52886 15.6597 8.30641 15.6597 10.6201L15.659 15.3346ZM4.32648 5.57036C3.46848 5.57036 2.77923 4.87586 2.77923 4.02161C2.77923 3.16811 3.46923 2.47436 4.32648 2.47436C5.18148 2.47436 5.87448 3.16811 5.87448 4.02161C5.87448 4.87586 5.18073 5.57036 4.32648 5.57036ZM5.66298 15.3346H2.98998V6.74561H5.66298V15.3346ZM16.9925 -0.00439453H1.65198C0.91773 -0.00439453 0.32373 0.576106 0.32373 1.29236V16.6989C0.32373 17.4158 0.91773 17.9956 1.65198 17.9956H16.9902C17.7237 17.9956 18.3237 17.4158 18.3237 16.6989V1.29236C18.3237 0.576106 17.7237 -0.00439453 16.9902 -0.00439453H16.9925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.494ae5f0f9f62ac429e44f90175290ce.svg";
export { ForwardRef as ReactComponent };